export var documentRef = {
  current: typeof document === 'undefined' ? null : document
};
export var windowRef = {
  current: typeof window === 'undefined' ? null : window
};
export { EventListener } from './EventListener';
export * from './types';
export { useEventListener } from './useEventListener';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fluentui/react-component-event-listener/dist/es/index.js
// module id = 1594
// module chunks = 0